export default "__VITE_ASSET__DT7pv3Sb__"